<template>
    <v-dialog persistent max-width="764" v-model="dialog">
        <v-form ref="form" action="/report/payroll/promoter/download/">
            <v-card>
                <v-card-title>Download Payroll Report</v-card-title>
                <v-card-text class="pb-0 my-1">
                    <input type="hidden" name="payroll" :value="object.payroll" />
                    <input type="hidden" name="type" :value="object.type" />
                    <input type="hidden" name="action" :value="object.action" />
                    <span class="text-subtitle-1">Are you sure that you want to download the payroll report?</span>
                </v-card-text>
                <v-card-actions class="pl-4 pr-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="close">Later</v-btn>
                    <v-btn text color="primary" @click="download">Download</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>


<script>

export default {
    name: 'PayrollPromoterDownloadDialog',
    data() {
        return {
            dialog: false,
            object: {
                type: '',
                payroll: '',
                action: '',
                start_date: ''
            }
        }
    },
    computed: {
        form() {
            return this.$refs.form
        }
    },
    methods: {
        open: function() {
            this.dialog = true
        },
        close: function() {
            this.dialog = false
        },
        updateObject: function(item) {
            this.object = item
        },
        download: function() {
            this.form.$el.submit()
            this.close()
            this.$emit('downloaded')
        }
    }
}

</script>